.container {
  margin-bottom: var(--space-xl);
}

.header {
  display: flex;
  align-items: center;
  gap: var(--space-md);
  margin-bottom: var(--space-md);
}

.label {
  font-family: var(--font-heading);
  font-size: var(--text-xs);
  letter-spacing: 2px;
  color: var(--text-muted);
}

.count {
  font-family: var(--font-code);
  font-size: var(--text-xs);
  color: var(--accent-cyan);
  flex: 1;
}

.clearBtn {
  font-size: 10px !important;
  padding: 2px 8px !important;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-sm);
}

.tagBtn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: transform var(--transition-fast);
}

.tagBtn:hover {
  transform: translateY(-1px);
}

.tagBtn.active :global(.tag) {
  background: rgba(0, 240, 255, 0.15);
  box-shadow: 0 0 8px var(--glow-cyan);
}
